export const SHARE_NOW_CUSTOMERS_SAY_EVENT_UA = ["clicked", "CustomersSay", "Share_now"] as const;
export const SHARE_NOW_CUSTOMERS_SAY_EVENT = { event: "cta_click", label: "share_now", placement: "customers_say" } as const;
